import * as types from "../types/index";
import { setInitialState } from "../InitialState";

const INITIAL_STATE = setInitialState({
  data: null,
});

export default function (state = INITIAL_STATE, action) {
  switch (action.type) {
    case types.CHANGE_PASSWORD_REQUEST:
      return {
        ...state,
        isFetching: true,
      };
    case types.CHANGE_PASSWORD_RECEIVE:
      return {
        ...state,
        isFetching: false,
        isSuccess: true,
        isError: false,
        data: action.payload.success,
      };
    case types.CHANGE_PASSWORD_FAILURE:
      return {
        ...state,
        isFetching: false,
        isError: true,
        isSuccess: false,
        data: action.payload.response.error,
      };
    case types.RESET_CHANGE_PASSWORD:
      return {
        ...state,
        isFetching: false,
        isError: false,
        isSuccess: false,
        data: null,
      };
    default:
      return {
        ...state,
      };
  }
}
